<template>
  <div class="row grid-margin grid-padding">
    <div class="col-xs-12 news-message" :class="'normal'">
      <div>
        <img class="newsIconStylling" src='@/static/img/newspaper-variant-outline.svg'>
        <span class="news-message__news" v-if="newsItem.Title && !html">{{ newsItem.Title }}</span>
        <span class="news-message__news" v-if="newsItem.Title && html" v-html="newsItem.Title"></span>
        <v-close class="news-message__close" @click.prevent="close"></v-close>
      </div>
      <div v-if="newsItem.IntroText && newsItem.IntroText.length < 140">
        <div v-if="!html" class="news-message__text">{{ newsItem.IntroText }}
          <router-link :to="'/nieuwsdetail/' + newsItem.Id" class="router_link">
              <span>Lees meer</span>
          </router-link>
        </div>
        <div v-else>
          <span class="news-message__htmltext" v-html="newsItem.IntroText"></span>
          <router-link :to="'/nieuwsdetail/' + newsItem.Id" class="router_link">
              <span>Lees meer</span>
          </router-link>
        </div>
      </div>
      <div v-else-if="newsItem.IntroText && newsItem.IntroText.length >= 140">
        <div v-if="!html" class="news-message__text">{{ newsItem.IntroText.substring(0,140) }}
          ...
          <router-link :to="'/nieuwsdetail/' + newsItem.Id" class="router_link">
              <span>Lees meer</span>
          </router-link>
        </div>
        <div v-else>
          <span class="news-message__htmltext" v-html="newsItem.IntroText.substring(0,140)"></span>
          ...
          <router-link :to="'/nieuwsdetail/' + newsItem.Id" class="router_link">
              <span>Lees meer</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VClose from 'icons/Close'

export default {
  name: 'NewsAlert',
  components: {
    VClose
  },
  props: {
    news: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },
    html: {
      type: Boolean,
      default: false
    },
    customLink: {
      type: Object,
      required: false
    },
    newsItem: {
      type: Object,
      required: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toggle (searchKey) {
      this.$emit('toggle', searchKey)
    }
  }
}
</script>
<style lang="scss" scoped>
.normal {
  background-color: $cyan-super-light;
  color: $cyan-super-dark;
  border: solid 1px $cyan-mega-light;
}
.router_link {
    text-decoration: underline;
    color: $cyan-super-dark;
    font-weight: bold;
    font-size: 12px;
}
.newsIconStylling {
    fill: $cyan-super-dark;
    display: inline-block;
    position: absolute;
    height: 20px !important;
    width: 20px !important;
}
.news-message {
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 5px !important;
  &__customLink {
    > a {
      color: $dark-orange !important;
    }
    cursor: pointer;
    margin-left: 0px !important;
  }
  &__urgent {
    fill: $medium-red;
    display: inline-block;
    position: absolute;
  }
  &__icon {
    fill: $cyan-super-dark;
    display: inline-block;
    position: absolute;
  }
  &__close {
    cursor: pointer;
    fill: $cyan-super-dark;
    top: 10px;
    right: 15px;
    float: right;
  }
  .material-design-icon {
    /deep/ svg {
      height: 20px !important;
      width: 20px !important;
    }
  }
  &__text {
    font-size: 12px;
    margin-left: 30px;
  }
  &__htmltext {
    font-size: 12px;
    margin-left: 30px;
  }
  &__news {
    font-size: 16px;
    font-weight: bold;
    margin-left: 30px;
  }
}
</style>
